<template>
  <div>
    <div class="pa-5 bg-white tab-company-setting">
      <!-- <v-tabs v-model="tab" grow>
        <v-tab
          href="#detail"
          class="subtitle-1 tab-live px-12 uppercast-unset"
          >{{ $vuetify.lang.t('$vuetify.company.companyDetail') }}</v-tab
        > -->
      <!-- <v-tab
          href="#tabbars"
          class="subtitle-1 tab-live px-12 uppercast-unset"
          >{{ $vuetify.lang.t('$vuetify.company.companyTabbar') }}</v-tab
        > -->
      <!-- <v-tab :href="tools" class="subtitle-1 tab-live px-12 uppercast-unset"
          >Marketing Tools</v-tab
        > -->
      <!-- </v-tabs> -->
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item value="detail">
        <!-- <div class="px-5 pt-2 pb-7">
          <warnningComponent
            v-bind:textInfo.sync="textWarning"
            v-bind:typestatus.sync="typeWarning"
            v-bind:alert.sync="showWarnnig"
          ></warnningComponent>
          <v-row>
            <v-col>
              <h2 class="mt-4">Company Detail</h2>
            </v-col>
          </v-row>
        </div> -->
        <newCompanyForm v-bind:id.sync="id_company"></newCompanyForm>
      </v-tab-item>
      <v-tab-item value="tabbars">
        <setting-tabbars v-bind:id.sync="id_company"></setting-tabbars>
      </v-tab-item>
      <v-tab-item :value="tools">
        <marketingTools v-bind:id.sync="id_company"></marketingTools>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="alert" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.courseList.sorry')
        }}</v-card-title>
        <v-card-text>
          <div
            v-html="
              $vuetify.lang.t(
                '$vuetify.courseManagement.courseList.alertPermissionFunction'
              )
            "
          ></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="alert = false">{{
            $vuetify.lang.t('$vuetify.courseManagement.courseList.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import newCompanyForm from './companyDetail';
import marketingTools from './marketingTools';
import settingTabbars from '../setting/menu';
import warnningComponent from '../../components/warningAlert.vue';
export default {
  components: {
    newCompanyForm,
    settingTabbars,
    marketingTools,
    // warnningComponent,
  },
  data() {
    return {
      tab: 'detail',
      id_company: '',
      textWarning: '',
      typeWarning: '',
      showWarnnig: false,
      alert: false,
      detail: '',
      tabbars: '',
      tools: '',
    };
  },

  methods: {
    async initialize() {
      this.id_company = this.$store.state.company._id;
      console.log(this.id_company);
    },
    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
        this.loading = false;
      }, 8000);
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style scoped>
.bg-white {
  background: #fff;
}

/* .tab-company-setting > .v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none !important;
} */
.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}

.tab-live {
  border-radius: 10px 10px 0 0;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}

.v-tab--active {
  background: #fff !important;
  color: #009bde;
  border-bottom: 0;
}

.uppercast-unset {
  text-transform: unset;
}
</style>
<style>
.v-tabs-slider-wrapper {
  height: 0 !important;
}
</style>
